import { PDFDocument } from "pdf-lib";
export const DOCUMENT_NAME_PATTERN = /^[a-zA-Z0-9 &$@=!\-_.)(']*$/;
export const isDocumentNameValid = (documentName) => {
  return DOCUMENT_NAME_PATTERN.test(documentName);
};
const readFile = (file) => {
  return new Promise<ArrayBuffer | string>((resolve, reject) => {
    const reader = new FileReader();

    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);

    reader.readAsArrayBuffer(file);
  });
};
export const getNumPages = (file) => {
  return new Promise<number>((resolve, reject) => {
    readFile(file)
      .then((arrayBuffer) => {
        PDFDocument.load(arrayBuffer)
          .then((pdf) => {
            resolve(pdf.getPageCount());
          })
          .catch(() => {
            reject(null);
          });
      })
      .catch(() => {
        reject(null);
      });
  });
};
export const getReleventFileSizeUnitFromBytes = (fileSizeInBytes) => {
  const fileSizeInMB = fileSizeInBytes / (1024 * 1024);
  const fileSizeInKB = fileSizeInBytes / 1024;
  let fileSizeDisplayName = "";
  if (fileSizeInMB >= 1) {
    fileSizeDisplayName = fileSizeInMB.toFixed(2) + " MB";
  } else {
    if (fileSizeInKB >= 1) {
      fileSizeDisplayName = fileSizeInKB.toFixed(2) + " KB";
    } else {
      fileSizeDisplayName = fileSizeInBytes.toFixed(2) + " B";
    }
  }
  return fileSizeDisplayName;
}
export function getFileExtension(filename) {
  return filename.split(".").pop();
}

